import React from "react";
import { DocumentoService } from "./../../../services";
import { DocumentoEntidade } from "./../../../entidades";

import { Button } from "@intech/web-ui";
import { FaFileDownload, FaFile } from "react-icons/fa";

interface IProps {
  documentos: Array<DocumentoEntidade>;
}

export const ListaDocumento: React.FC<IProps> = ({
  documentos
}) => {

  async function BaixarDocumento(doc: DocumentoEntidade) {
    try {
      const documentoInfo = await DocumentoService.BuscarPorOidDocumento(doc.OID_DOCUMENTO);
      const documento = await DocumentoService.Download(doc.OID_DOCUMENTO);

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(
          new Blob([documento]),
          documentoInfo.NOM_ARQUIVO_LOCAL
        );
      } else {
        const url = window.URL.createObjectURL(new Blob([documento]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", documentoInfo.NOM_ARQUIVO_LOCAL);
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    }
    catch (e) {
      const error = e.response ? "Houve um erro ao baixar o arquivo." : e;
      window.alert(error);
    }
  };

  function renderDocumentoTabela() {
    return documentos.map(
      (doc: DocumentoEntidade, index: number) => {
        return (
          <tr key={index}>
            <td style={{ "width": "50px" }}>
              <FaFile color={"#17a2b8"} size={26} />
            </td>
            <td>
              <Button
                type={"light"}
                icon={<FaFileDownload />}
                onClick={() => BaixarDocumento(doc)}
                title={doc.TXT_TITULO}
                usesLoading
                loadingText={"Baixando..."}
              />
            </td>
          </tr>
        );
      }
    );
  };

  return (<>{renderDocumentoTabela()}</>);
}
